import { cn } from '@navinc/base-react-components'
import { Icon } from '@navinc/base-react-components/wayfinder'
import { LexicalRichText, LexicalRichTextContent } from '@/app/_components/RichText/lexical.jsx'

export type AlertBannerProps = {
  intent?: 'info' | 'warning' | 'tip' | 'note' | null
  richText?: LexicalRichTextContent
}

const intentClasses: Record<NonNullable<AlertBannerProps['intent']>, string> = {
  info: 'bg-primaryContainer text-onPrimaryDim',
  warning: 'bg-warnContainer text-onWarnContainer',
  tip: 'bg-[#EDECFC] text-onPrimaryContainer',
  note: 'bg-superContainer text-onSuperContainer',
}

const icons: Record<NonNullable<AlertBannerProps['intent']>, string> = {
  info: 'info',
  warning: 'warning',
  tip: 'lightbulb',
  note: 'description',
}

export const AlertBanner = ({ intent, richText }: AlertBannerProps) => {
  const alertIntent = intent ?? 'info'
  return (
    <div className={cn('p-300 pb-100 flex items-start rounded-200 gap-100', intentClasses[alertIntent])}>
      <Icon name={icons[alertIntent]} size="medium" color="inherit" className="mt-px" />
      <div>{richText && <LexicalRichText content={richText} />}</div>
    </div>
  )
}
